import { useMutation } from 'react-query';

import { addOwnerForClient } from 'api/clients/clientSmartCreation/addOwnerForClient';

export const useCreateOwnerForClient = () => {
  const { mutate: createOwner, isLoading } = useMutation(addOwnerForClient);

  return { createOwner, isLoading };
};
